export default "__VITE_ASSET__8046b35b__"